import { Seo } from "../components/Seo";
import { Eyebrow, Reveal } from "../components/ui-bits";
import { CTABand } from "../components/PageSections";

const PHOTOS = [
  {
    src: "https://images.unsplash.com/photo-1572454591674-2739f30d8c40?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Rose arrangement designed at JIF Flowers, Coventry RI",
  },
  {
    src: "https://images.unsplash.com/photo-1606101083393-bded314215cd?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Colorful mixed birthday bouquet from the JIF shop",
  },
  {
    src: "https://images.unsplash.com/photo-1558879787-4c4aea1fbb83?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Romantic rose bouquet designed in-shop",
  },
  {
    src: "https://images.unsplash.com/photo-1558879860-45f24b366ea1?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Bright seasonal arrangement ready for delivery",
  },
  {
    src: "https://images.pexels.com/photos/34041965/pexels-photo-34041965.jpeg?auto=compress&cs=tinysrgb&w=1000",
    alt: "Inside the JIF Flowers shop on Main Street, Coventry",
  },
  {
    src: "https://images.pexels.com/photos/5414032/pexels-photo-5414032.jpeg?auto=compress&cs=tinysrgb&w=1000",
    alt: "Soft pastel bouquet for a new baby celebration",
  },
  {
    src: "https://images.unsplash.com/photo-1724152312974-d4d48b8b36fd?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "White lily sympathy tribute designed at JIF Flowers",
  },
  {
    src: "https://images.unsplash.com/photo-1674784708710-0f03d1868ed3?crop=entropy&cs=srgb&fm=jpg&q=85",
    alt: "Peaceful white floral arrangement hand-delivered in Kent County",
  },
  {
    src: "/images/gallery-daisy-jar.webp",
    alt: "Daisy and peach rose jar bouquet fresh from the JIF design bench",
  },
  {
    src: "/images/gallery-sunflower-bouquet.webp",
    alt: "Sunflower and orange rose bouquet made in the Coventry shop",
  },
  {
    src: "/images/gallery-shop-dog.webp",
    alt: "The JIF shop dog greeting customers beside a handmade Christmas boxwood tree",
  },
  {
    src: "/images/gallery-gerbera-closeup.webp",
    alt: "Pink gerbera daisy and rose bouquet close-up at JIF Flowers",
  },
  {
    src: "/images/gallery-white-roses.webp",
    alt: "White rose and hydrangea arrangement designed at JIF Flowers",
  },
];

export default function Gallery() {
  return (
    <>
      <Seo
        title="Flower Arrangements Gallery | JIF Flowers Coventry RI"
        description="A look inside the design bench at JIF – Jack Iannotti Flowers in Coventry, RI: bouquets, sympathy tributes, and seasonal arrangements. Call (401) 822-4440."
      />
      <section className="mx-auto max-w-7xl px-5 pb-16 pt-40 sm:px-8">
        <Reveal>
          <Eyebrow>The Gallery</Eyebrow>
          <h1 className="mt-5 max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl lg:text-6xl">
            From Our Design Bench
          </h1>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-charcoal/85 sm:text-[18px]">
            A glimpse of what leaves the shop each week. Like something you see? Call and describe it — every
            arrangement we make starts as a conversation.
          </p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.08}>
              <div className="group overflow-hidden rounded-xl" data-testid={`gallery-item-${i}`}>
                <img
                  src={p.src}
                  alt={p.alt}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${
                    i % 3 === 0 ? "aspect-[3/4]" : "aspect-square"
                  }`}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand title="See something you love? Call the shop" />
    </>
  );
}
